<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>العلاوات و البونص</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                              هنا يتم عرض جميع العلاوات و البونص
                                <div class='pull-left' style='padding=0px'>
                                    <button @click='showForm(0)' type='button' class='btn btn-outline btn-primary btn-sm ' style='padding:3px;width: 80px' data-toggle='modal' data-target='#myModal'>
                                      <b>  إضافة جديد </b>
                                    </button>
                                </div>
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                    <thead>
                                      <tr>

                                          <th style='text-align: center'>الفرع</th>
                                          <th style='text-align: center'>الموظف</th>
                                          <th style='text-align: center'>المبلغ</th>
                                          <th style='text-align: center'>الشهر</th>
                                          <th style='text-align: center'>ملاحظات</th>
                                          <th style='text-align: center'>الاجراء</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                        <tr class='odd gradeX' v-for='record in records' :key='record.id'>

                                          <td align='center'>{{record.branche_id}}</td>
                                          <td align='center'>{{record.emp_id}}</td>
                                          <td align='center'>{{record.amount}}</td>
                                          <td align='center'>{{record.month}}</td>
                                          <td align='center'>{{record.notes}}</td>
                                          <td align='center'>
                                              <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                                              <button @click='deleteData(record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                                              <button @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>تعديل</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- Modal -->
             <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
                 <div class='modal-dialog  modal-lg'>
                     <div class='modal-content'>
                         <div class='modal-header'>
                             <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
                             <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
                         </div>
                         <form role='form'>
                         <div class='modal-body'>
                           <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                             <ul v-if='validationErrors'>
                                 <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                             </ul>
                           </div>
                           <div class='alert alert-success alert-dismissable' v-if='successShow'>
                              {{success}}
                           </div>
                           <fieldset>
                                 <input v-model='record.id' name='id' type='text' hidden>

                                 <div class='form-group col-lg-6 col-sm-6'>
                                     <label>الفرع:</label>
                                     <input v-model='record.branche_id' class='form-control' name='branche_id' type='text'>
                                 </div>
                                 <div class='form-group col-lg-6 col-sm-6'>
                                     <label>الموظف:</label>
                                     <input v-model='record.emp_id' class='form-control' name='emp_id' type='text'>
                                 </div>
                                 <div class='form-group col-lg-6 col-sm-6'>
                                     <label>المبلغ:</label>
                                     <input v-model='record.amount' class='form-control' name='amount' type='text'>
                                 </div>
                                 <div class='form-group col-lg-6 col-sm-6'>
                                     <label>الشهر:</label>
                                     <input v-model='record.month' class='form-control' name='month' type='text'>
                                 </div>
                                 <div class='form-group col-lg-6 col-sm-6'>
                                     <label>ملاحظات:</label>
                                     <input v-model='record.notes' class='form-control' name='notes' type='text'>
                                 </div>
                               </fieldset>
                           </div>
                           <div class='modal-footer'>
                               <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
                               <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                               <button @click='saveData' type='button' class='btn btn-primary'>حفظ</button>
                           </div>
                         </form>
                     </div>
                     <!-- /.modal-content -->
                 </div>
                 <!-- /.modal-dialog -->
             </div>
             <!-- /.modal -->
             <!-- /.container-fluid -->
        </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'Bonus',
  data () {
    return {
      validationErrors: '',
      records: {},
      record: {},
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      title: ''
    }
  },
  created () {
    this.GetData()
  },
  methods: {
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getAdvance', {
        token: localStorage.getItem('token')
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        this.title = 'إضافة سجل جديد'
        this.record = {'id': 0, 'branche_id': '', 'emp_id': '', 'amount': '', 'month': '', 'notes': ''}
      } else {
        this.title = 'تعديل بيانات سجل'
        this.record = {'id': recID.id, 'branche_id': recID.branche_id, 'emp_id': recID.emp_id, 'amount': recID.amount, 'month': recID.month, 'notes': recID.notes}
      }
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'saveAdvance', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        uid: this.record.uid,
        branche_id: this.record.branche_id,
        emp_id: this.record.emp_id,
        amount: this.record.amount,
        month: this.record.month,
        notes: this.record.notes,
        user_id: this.record.user_id
      })
        .then(res => {
          this.isLoadingSave = false
          if (this.record.id === 0) {
            this.records.push(res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          } else {
            let i = this.records.map(record => record.id).indexOf(this.record.id)
            this.records.splice(i, 1, res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'deleteAdvance', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(recID)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/employees/Bonus.vue